module.exports = __webpack_public_path__ + "static/media/uzvicnik.84386b3b.svg";